export function returnNullIfObjectEmpty(obj: any): null | void {
  if (!obj || obj.length < 1) {
    return null;
  }
}
